export const namespaces = ['variantCommon', 'common'];
